import React, { useRef } from 'react';
import { MenuCard } from './MenuCard';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { PotatoIcon } from './SectionIcons';
export function BakedPotatoes() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="w-full bg-bp-bg py-20 px-6 md:px-20" data-id="element-7">
      <div className="max-w-container mx-auto" data-id="element-8">
        <motion.div ref={ref} className="mb-16 text-center" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} data-id="element-9">
          <PotatoIcon className="mx-auto mb-4" data-id="element-10" />
          <h2 className="font-display text-[32px] md:text-[48px] leading-none text-bp-text tracking-[0.1em] uppercase mb-4" data-id="element-11">
            PAPAS HORNEADAS
          </h2>
          <p className="font-body font-light text-bp-text2 text-base md:text-lg" data-id="element-12">
            Papa capira. Horneada al momento.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 max-w-4xl mx-auto" data-id="element-13">
          <MenuCard name="BBQ POLLO" price="20.000" ingredients={['Papa capira horneada.', 'Pollo BBQ ahumado.', 'Mezcla de quesos.', 'Sour cream.']} delay={0} data-id="element-14" />

          <MenuCard name="PERUANA DE RES" price="20.000" ingredients={['Papa capira horneada.', 'Res marinada.', 'Cebolla y pimentón salteados.', 'Mezcla de quesos.', 'Guacamole.']} delay={0.1} data-id="element-15" />
        </div>
      </div>
    </section>;
}